
import { Options, Prop, Vue, Watch } from 'vue-property-decorator'

import Image from '../Image.vue'

@Options({
  name: 'ContentImage',
  components: {
    Image
  },
  inheritAttrs: false
})
export default class ContentImage extends Vue {
  @Prop({ type: String })
  readonly imageUrl?: string

  @Prop({ type: String })
  readonly previewUrl?: string

  @Prop({
    type: Boolean,
    default: false
  })
  readonly isLcp!: boolean

  observer: IntersectionObserver | null = null
  isActive: boolean | null = null
  isPlaying = false

  get container () {
    return this.$parent?.$el?.closest('a') ?? this.$parent?.$el?.querySelector('a')
  }

  get play () {
    return () => {
      this.isActive = true
      setTimeout(async () => {
        await (this.$refs.video as HTMLMediaElement | null)?.play()
        this.isPlaying = true
      })
    }
  }

  get stop () {
    return async () => {
      this.isPlaying = false
      await (this.$refs.video as HTMLMediaElement | null)?.pause()
    }
  }

  canHover () {
    return window.matchMedia('(any-hover: hover)').matches
  }

  mounted () {
    if (this.previewUrl && !navigator.userAgent.includes('Googlebot') && !navigator.userAgent.includes('Google-InspectionTool')) {
      if (this.canHover()) {
        this.container?.addEventListener('mouseenter', this.play)
        this.container?.addEventListener('mouseleave', this.stop)
      } else {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.container) {
              if (entry.intersectionRatio > 0.75) {
                this.play()
              } else {
                this.stop()
              }
            }
          })
        }, { threshold: [0, 0.25, 0.5, 0.75, 1] })

        this.observer.observe(this.container)
      }
    }
  }

  unmounted () {
    if (this.previewUrl) {
      if (this.canHover()) {
        this.container?.removeEventListener('mouseenter', this.play)
        this.container?.removeEventListener('mouseleave', this.stop)
      }

      this.observer?.disconnect()
    }
  }
}
